






import Vue from 'vue';
import AccountCircle from './icons/AccountCircle.vue';
import ArrowBack from './icons/ArrowBack.vue';
import ArrowForward from './icons/ArrowForward.vue';
import ArrowUp from './icons/ArrowUp.vue';
import Camera from './icons/Camera.vue';
import Check from './icons/Check.vue';
import Close from './icons/Close.vue';
import CloseCircle from './icons/CloseCircle.vue';
import Delete from './icons/Delete.vue';
import DropDown from './icons/DropDown.vue';
import DropUp from './icons/DropUp.vue';
import Edit from './icons/Edit.vue';
import File from './icons/File.vue';
import Info from './icons/Info.vue';
import Locker from './icons/Locker.vue';
import Location from './icons/Location.vue';
import Menu from './icons/Menu.vue';
import NotificationAlt from './icons/NotificationAlt.vue';
import PlayArrow from './icons/PlayArrow.vue';
import Search from './icons/Search.vue';
import Secretary from './icons/Secretary.vue';
import Timer from './icons/Timer.vue';
import Upload from './icons/Upload.vue';
import Accessibility from './icons/Accessibility.vue';

interface Icons {
  [name: string]: Vue.Component;
}

const icons: Icons = {
  accessibility: Accessibility,
  accountCircle: AccountCircle,
  arrowBack: ArrowBack,
  arrowForward: ArrowForward,
  arrowUp: ArrowUp,
  camera: Camera,
  check: Check,
  close: Close,
  closeCircle: CloseCircle,
  delete: Delete,
  dropdown: DropDown,
  dropup: DropUp,
  edit: Edit,
  file: File,
  info: Info,
  locker: Locker,
  location: Location,
  menu: Menu,
  notificationAlt: NotificationAlt,
  playArrow: PlayArrow,
  search: Search,
  secretary: Secretary,
  timer: Timer,
  upload: Upload,
};

interface Data {
  icons: Icons;
}

export default Vue.extend({
  props: {
    name: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: 24,
    },
  },
  data(): Data {
    return {
      icons: icons,
    };
  },
  computed: {
    icon(): Vue.Component {
      return this.icons[this.name];
    },
  },
});
